// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"136":"64ce005b","166":"35560b51","227":"a0b0104c","511":"043d932d","801":"c1a0bcc3"}[chunkId] + ".chunk.css";
};